import type { RootState } from '@/app/store/store';

export const selectTheme = (s: RootState): RootState['ui']['theme'] => s.ui.theme;

export const selectSidebarCollapsed = (s: RootState): boolean => s.ui.sidebarCollapsed;

export const selectMobileSidebarOpen = (s: RootState): boolean => s.ui.mobileSidebarOpen;

export const selectCommandPaletteOpen = (s: RootState): boolean => s.ui.commandPaletteOpen;
